import Joi from 'joi-full';
import { formValueSelector } from 'redux-form';

import { syncValidateData } from '../../../../common/validator';

const schema = Joi.object().keys({
  products: Joi.object().pattern(/^[\w-]+$/, Joi.object().keys({
    quantity: Joi.number().optional().min(0).label('Quantity'),
  })),
});

const validate = values => syncValidateData(values, schema);

const PO_FORM = 'PO_FORM';

export const formConfig = {
  form: PO_FORM,
  validate,
};

export const poFormValueSelector = formValueSelector(PO_FORM);
